var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTermLife(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_1",
    height: "512px",
    viewBox: "0 0 512 512",
    width: "512px",
    "data-name": "Layer 1",
    className: "hovered-paths",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m271.042 59.078c-4.936-.4-9.911-.61-14.918-.61-.043 0-.084 0-.124 0h-.243c-89.4.059-163.931 64.811-179.246 149.863.118-.129.235-.256.354-.382.083-.088.169-.175.258-.258a54.337 54.337 0 0 1 32.935-15.029c19.876-72.647 83.689-127.328 160.984-133.584z",
    fill: "#d4e1f4",
    "data-original": "#D4E1F4"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m256.124 46.468h-.371c-107.111.071-194.194 87.269-194.123 194.379a6 6 0 0 0 11.8 1.528c1.348-5.1 6.124-19.646 12.055-26.077a42.309 42.309 0 0 1 29.265-11.843h.2a41.2 41.2 0 0 1 28.971 11.8 42.3 42.3 0 0 1 11.894 29.29 6 6 0 0 0 12 0 40.483 40.483 0 0 1 41.32-41.094 41.206 41.206 0 0 1 28.972 11.8 42.3 42.3 0 0 1 11.893 29.297v16.264h12v-16.264a40.474 40.474 0 0 1 41.121-41.089h.2a41.2 41.2 0 0 1 28.969 11.8 42.306 42.306 0 0 1 11.893 29.29 6 6 0 0 0 12 0 40.482 40.482 0 0 1 41.324-41.094 41.2 41.2 0 0 1 28.964 11.8c5.953 6.407 10.746 21.008 12.095 26.113a6 6 0 0 0 11.8-1.528v-.24a194.252 194.252 0 0 0 -194.242-194.132zm179.011 161.484c-.054-.057-.109-.114-.165-.168a53.122 53.122 0 0 0 -37.693-15.325 54.113 54.113 0 0 0 -37.6 15.236c-.088.083-.174.169-.257.257a57.691 57.691 0 0 0 -9.236 12.924 57.659 57.659 0 0 0 -9.236-12.924c-.053-.057-.108-.114-.164-.168a53.111 53.111 0 0 0 -37.432-15.326 54.1 54.1 0 0 0 -37.86 15.242c-.087.083-.173.168-.256.256a57.635 57.635 0 0 0 -9.236 12.917 57.642 57.642 0 0 0 -9.236-12.925c-.053-.057-.108-.114-.164-.168a53.245 53.245 0 0 0 -37.692-15.325 54.113 54.113 0 0 0 -37.6 15.236c-.088.083-.173.169-.256.257a57.642 57.642 0 0 0 -9.236 12.925 57.674 57.674 0 0 0 -9.236-12.925c-.054-.057-.108-.114-.164-.168a53.243 53.243 0 0 0 -37.692-15.325 54.109 54.109 0 0 0 -37.6 15.236c-.089.083-.175.17-.258.258-.119.126-.236.253-.354.382 15.315-85.052 89.845-149.8 179.246-149.863h.242.124a182.371 182.371 0 0 1 179.4 149.909q-.192-.214-.389-.425z",
    fill: "#0635c9",
    "data-original": "#0635C9",
    className: "",
    style: {
      fill: "#2F55D4"
    },
    "data-old_color": "#0635c9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m256 378.015a6 6 0 0 0 -6 6v31.728a37.79 37.79 0 0 1 -75.579 0v-20.713a6 6 0 0 0 -12 0v20.713a49.79 49.79 0 0 0 99.579 0v-31.728a6 6 0 0 0 -6-6z",
    fill: "#0635c9",
    "data-original": "#0635C9",
    className: "",
    style: {
      fill: "#2F55D4"
    },
    "data-old_color": "#0635c9"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#1ae5be"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m255.211 256.54a66 66 0 1 0 66 66 66.074 66.074 0 0 0 -66-66zm0 120a54 54 0 1 1 54-54 54.061 54.061 0 0 1 -54 54z",
    "data-original": "#1AE5BE",
    className: "hovered-path active-path",
    style: {
      fill: "#2ECA8B"
    },
    "data-old_color": "#1AE5BE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m255.211 299.3a8.467 8.467 0 0 1 8.457 8.457 6 6 0 1 0 12 0 20.49 20.49 0 0 0 -14.457-19.557v-2.846a6 6 0 0 0 -12 0v2.846a20.456 20.456 0 0 0 6 40.013 8.455 8.455 0 0 1 .1 16.91c-.032 0-.064 0-.1 0s-.064 0-.1 0a8.465 8.465 0 0 1 -8.361-8.453 6 6 0 0 0 -12 0 20.491 20.491 0 0 0 14.458 19.556v3.5a6 6 0 0 0 12 0v-3.5a20.456 20.456 0 0 0 -6-40.013 8.458 8.458 0 1 1 0-16.915z",
    "data-original": "#1AE5BE",
    className: "hovered-path active-path",
    style: {
      fill: "#2ECA8B"
    },
    "data-old_color": "#1AE5BE"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTermLife);
export default __webpack_public_path__ + "static/media/term-life.99f14b2905c3d9fa5d8e5e1ed13e7290.svg";
export { ForwardRef as ReactComponent };